function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.517 5.16c.666-.373 1.483.117 1.483.89v.113c0 .56.448 1.015 1 1.015s1-.454 1-1.015V6.05c0-2.317-2.45-3.785-4.45-2.666L9.243 9.716H4c-1.657 0-3 1.363-3 3.045v6.09c0 1.681 1.343 3.044 3 3.044h1.5c.552 0 1-.454 1-1.015 0-.56-.448-1.015-1-1.015H4c-.552 0-1-.454-1-1.015v-6.09c0-.56.448-1.014 1-1.014h4.5v3.044c0 .561.448 1.015 1 1.015s1-.454 1-1.014V11.33l11.017-6.17zM25 16.82c0-.56-.448-1.015-1-1.015s-1 .455-1 1.015v8.742c0 .772-.817 1.261-1.483.888l-6.534-3.659a.992.992 0 00-1.359.399 1.023 1.023 0 00.393 1.379l6.534 3.659c2 1.12 4.449-.349 4.449-2.666V16.82zM29.636 7.454c.426-.356.487-.996.136-1.428a.99.99 0 00-1.408-.139l-25.5 21.314a1.025 1.025 0 00-.136 1.43.99.99 0 001.408.137l25.5-21.314z",
  fill: "currentColor"
})));